import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import moment from "moment";
import { Subscription } from "rxjs";
import { AppService } from "src/app/core/services/app.service";
import { CustomerService } from "src/app/core/services/customer.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { UserService } from "src/app/core/services/user.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { CustomerDto } from "src/app/shared/models/DTO/customer-dto";

@Component({
	selector: "app-customer-dashboard",
	templateUrl: "./customer-dashboard.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class CustomerDashboardComponent implements OnInit, OnDestroy {
	customerSelected: CustomerDto;

	customerList: CustomerDto[];
	customerListSubscription: Subscription = new Subscription();

	moment: any = moment;
	totalRecords: number = 0;

	constructor(
		public app: AppService,
		private focuslink: FocuslinkService,
		private route: ActivatedRoute,
		public customerService: CustomerService,
		public userService: UserService,
		public venueService: OOVenueService,
		private router: Router
	) {}
	ngOnDestroy(): void {
		this.customerListSubscription.unsubscribe();
	}

	ngOnInit(): void {
		const customerKey = this.route.snapshot.paramMap.get("customerKey");
		this.customerListSubscription.add(
			this.customerService.customerList.subscribe((customerList) => {
				if (customerList && customerList.length > 0) {
					this.customerList = customerList;
				}
			})
		);
		if (this.customerService.currentVenueKey === this.venueService.subscriptionVenue.value.key || this.customerService.customerList.value.length === 0) {
			this.customerService.initCustomerService();
		}
	}

	async getCustomerOne(customerKey: string) {
		this.app.loading(true);
		const resp = await this.focuslink.customerGetOne(this.customerService.venueService.venueKey, customerKey);
		this.customerSelected = new CustomerDto(resp);
	}

	viewProfile(customerKey: string) {
		const link = document.createElement("a");
		link.href = `http://localhost:4200/aboutme?customerKey=${btoa(`${customerKey}#${this.userService.user.key}`)}`;
		link.target = "_blank";
		link.click();
	}

	routeToCustomer(customerKey: string) {
		this.router.navigate([`/cc/customers/${customerKey}`]);
	}
}
